import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
export class ErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        this.props.onError?.(error, info);
        if (typeof window !== 'undefined' && import.meta.env.MODE === 'development') {
            // Surface errors clearly in dev — Sentry handles them in prod.
            console.error('[ErrorBoundary]', error, info.componentStack);
        }
    }
    reset = () => {
        this.setState({ error: null });
    };
    render() {
        const { error } = this.state;
        if (!error)
            return this.props.children;
        if (this.props.fallback)
            return this.props.fallback(error, this.reset);
        const isApp = this.props.scope !== 'module';
        return (_jsx("div", { role: "alert", className: isApp
                ? 'flex min-h-screen items-center justify-center bg-background p-6'
                : 'rounded-md border border-destructive/30 bg-destructive/5 p-4', children: _jsxs("div", { className: "max-w-md text-center", children: [_jsx("h2", { className: "text-xl font-semibold", children: "Something went wrong." }), _jsx("p", { className: "mt-2 text-sm text-muted-foreground", children: isApp
                            ? 'The application crashed. Reload the page or try again.'
                            : 'This section failed to load. Try again.' }), import.meta.env.MODE === 'development' && (_jsx("pre", { className: "mt-4 overflow-auto rounded bg-muted p-3 text-left text-xs", children: error.message })), _jsx("button", { type: "button", onClick: this.reset, className: "mt-4 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground", children: "Try again" })] }) }));
    }
}
